import React, { memo } from 'react'
import { Select } from 'components/forms/Selects'

interface IInsuranceSelectProps {
  id: string
  label: string
  value?: string
  onChange: (...args: any[]) => any
  options: {
    value: string
    label: string
  }[]
}
const InsuranceSelect: React.FunctionComponent<IInsuranceSelectProps> = memo(
  ({ id, label, onChange, options, value }) => (
    <div className='col-xs-8'>
      <Select
        id={id}
        label={label}
        options={options}
        value={options.find(option => option.value === value)}
        onChange={onChange}
        dataTest={id}
      />
    </div>
  )
)

export default InsuranceSelect
